import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Motion";
import { PhoneFrame } from "./PhoneFrame";
import { StoreButtons } from "./StoreButtons";

export const AppFeature = ({ app, reverse = false, dark = false }) => (
  <article data-testid={`app-feature-${app.id}`} className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
    <FadeUp className={`lg:col-span-6 ${reverse ? "lg:order-2" : ""}`}>
      <Link to={`/portfolio/${app.id}`} data-testid={`app-visual-link-${app.id}`} className={`group relative block overflow-hidden rounded-[2rem] bg-gradient-to-br ${app.tint} px-8 py-12 sm:px-12`}>
        <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#0D6EFD]/30 blur-3xl" />
        <div className="relative mx-auto flex max-w-[420px] items-end justify-center gap-4">
          <PhoneFrame src={app.screens[0].src} alt={`${app.name} screenshot`} testId={`app-screenshot-${app.id}`} className="w-[56%] transition-transform duration-700 group-hover:-translate-y-2 group-hover:rotate-[-1.5deg]" />
          <PhoneFrame src={app.screens[1].src} alt={`${app.name} second screenshot`} className="mb-8 w-[44%] rotate-[4deg] transition-transform duration-700 group-hover:rotate-[6deg]" />
        </div>
      </Link>
    </FadeUp>
    <FadeUp delay={0.1} className="lg:col-span-6">
      <div className="flex flex-wrap items-center gap-2">
        <span className={`font-mono text-xs uppercase tracking-[0.2em] ${dark ? "text-[#7fb2ff]" : "text-[#0D6EFD]"}`}>{app.kind}</span>
        {app.platforms.map((p) => (
          <span key={p} className={`rounded-full border px-3 py-0.5 text-xs font-medium ${dark ? "border-white/15 text-slate-200" : "border-slate-300 text-slate-700"}`}>{p}</span>
        ))}
      </div>
      <h3 className={`font-display mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl ${dark ? "text-white" : "text-[#0B132B]"}`}>{app.name}</h3>
      <p className={`mt-3 text-lg font-medium ${dark ? "text-slate-200" : "text-slate-800"}`}>{app.tagline}</p>
      <p className={`mt-4 leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{app.description}</p>
      <ul className="mt-6 space-y-3">
        {app.features.slice(0, 4).map((f) => (
          <li key={f} className={`flex items-start gap-3 text-sm sm:text-base ${dark ? "text-slate-200" : "text-slate-700"}`}>
            <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-[#0D6EFD] text-white"><Check className="h-3 w-3" /></span>
            {f}
          </li>
        ))}
      </ul>
      <div className="mt-8"><StoreButtons app={app} dark={dark} /></div>
      <Link to={`/portfolio/${app.id}`} data-testid={`app-details-link-${app.id}`} className={`group mt-6 inline-flex items-center gap-2 text-sm font-bold ${dark ? "text-[#7fb2ff]" : "text-[#0D6EFD]"}`}>
        See all features & screenshots <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
      </Link>
    </FadeUp>
  </article>
);
